import { NgModule } from '@angular/core';

import { RedirectServiceModule } from '@fcom/common-booking/modules/redirect-service/redirect-service.module';

import { MmbOrderService } from './services/mmb-order.service';
import { OrderPreviewsService } from './services/order-previews.service';

@NgModule({
  imports: [RedirectServiceModule],
  exports: [],
  declarations: [],
  providers: [MmbOrderService, OrderPreviewsService],
})
export class MmbOrderModule {}
